import { render, staticRenderFns } from "./ModalStoreList.vue?vue&type=template&id=60565888&scoped=true"
import script from "./ModalStoreList.vue?vue&type=script&lang=js"
export * from "./ModalStoreList.vue?vue&type=script&lang=js"
import style0 from "./ModalStoreList.vue?vue&type=style&index=0&id=60565888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60565888",
  null
  
)

export default component.exports